import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../App';
import api from '../api';
import { rolde } from '../yetki';

function GenelTanimlar({ baslik, endpoint, kolonlar, yeniForm, formRender }) {
  const { kullanici } = useContext(AuthContext);
  const [liste, setListe] = useState([]);
  const [form, setForm] = useState(yeniForm);
  const [modalAcik, setModalAcik] = useState(false);
  const [duzenleme, setDuzenleme] = useState(null);
  const [hata, setHata] = useState('');
  const yazabilir = rolde(kullanici, 'admin', 'mudur');

  useEffect(() => { yukle(); }, []);
  const yukle = () => api.get(`/tanimlar/${endpoint}`).then(r => setListe(r.data));

  const ac = (kayit) => {
    setDuzenleme(kayit);
    setForm(kayit ? { ...yeniForm, ...kayit } : { ...yeniForm });
    setHata(''); setModalAcik(true);
  };

  const kaydet = async (e) => {
    e.preventDefault(); setHata('');
    try {
      if (duzenleme) await api.put(`/tanimlar/${endpoint}/${duzenleme.id}`, form);
      else await api.post(`/tanimlar/${endpoint}`, form);
      yukle(); setModalAcik(false);
    } catch (err) { setHata(err.response?.data?.hata || 'Hata oluştu'); }
  };

  const sil = async (kayit) => {
    if (!window.confirm(`"${Object.values(kayit).find((v, i) => i > 0 && typeof v === 'string') || kayit.id}" kaydını pasife almak istediğinizden emin misiniz?`)) return;
    try {
      await api.delete(`/tanimlar/${endpoint}/${kayit.id}`);
      yukle();
    } catch (err) { alert(err.response?.data?.hata || 'Silinemedi'); }
  };

  return (
    <div>
      {yazabilir && (
        <div style={{display:'flex', justifyContent:'space-between', marginBottom:'12px'}}>
          <strong>{baslik}</strong>
          <button className="btn btn-primary btn-sm" onClick={() => ac(null)}>+ Ekle</button>
        </div>
      )}
      <table>
        <thead>
          <tr>{kolonlar.map(k => <th key={k.key}>{k.label}</th>)}{yazabilir && <th>İşlem</th>}</tr>
        </thead>
        <tbody>
          {liste.map(r => (
            <tr key={r.id}>
              {kolonlar.map(k => (
                <td key={k.key}>
                  {k.render ? k.render(r[k.key], r) : (r[k.key] === true ? '✅' : r[k.key] === false ? '❌' : r[k.key] ?? '—')}
                </td>
              ))}
              {yazabilir && (
                <td style={{display:'flex', gap:'4px'}}>
                  <button className="btn btn-outline btn-xs" onClick={() => ac(r)}>Düzenle</button>
                  <button className="btn btn-outline btn-xs" style={{color:'#c62828'}} onClick={() => sil(r)}>Sil</button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>

      {modalAcik && (
        <div className="modal-overlay" onClick={e => e.target===e.currentTarget && setModalAcik(false)}>
          <div className="modal" style={{maxWidth:'450px'}}>
            <div className="modal-header">
              <span className="modal-title">{duzenleme ? 'Düzenle' : `Yeni ${baslik}`}</span>
              <button className="modal-close" onClick={() => setModalAcik(false)}>×</button>
            </div>
            {hata && <div className="alert alert-error">{hata}</div>}
            <form onSubmit={kaydet}>
              {formRender(form, setForm, duzenleme)}
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setModalAcik(false)}>İptal</button>
                <button type="submit" className="btn btn-primary">Kaydet</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default function Tanimlar() {
  const [aktifTab, setAktifTab] = useState('faaliyet');
  const TABS = [
    ['faaliyet','Faaliyet Türleri'],['ruhsat','Ruhsat Türleri'],['sicil','Sicil Tipleri'],
    ['sirket','Şirket Tipleri'],['iptal','İptal Nedenleri'],['belge','Belge Türleri'],
    ['nace','NACE Kodları'],
  ];

  return (
    <div>
      <h2 style={{color:'#1a237e', marginBottom:'20px'}}>📚 Tanımlar</h2>
      <div className="tabs" style={{flexWrap:'wrap'}}>
        {TABS.map(([k,v]) => (
          <button key={k} className={`tab ${aktifTab===k ? 'active' : ''}`} onClick={() => setAktifTab(k)}>{v}</button>
        ))}
      </div>
      <div className="card">
        {aktifTab==='faaliyet' && (
          <GenelTanimlar
            baslik="Faaliyet Türleri" endpoint="faaliyet-turleri"
            yeniForm={{ faaliyet_kodu:'', faaliyet_adi:'', sinif_adi:'Sıhhi', aktif:true }}
            kolonlar={[
              { key:'faaliyet_kodu', label:'Kod', render: v => <span style={{fontFamily:'monospace', fontSize:'12px'}}>{v}</span> },
              { key:'faaliyet_adi', label:'Faaliyet Adı' },
              { key:'sinif_adi', label:'Sınıf', render: v => <span style={{fontSize:'11px', padding:'2px 8px', borderRadius:'10px', background:'#e8eaf6', color:'#3949ab'}}>{v}</span> },
              { key:'aktif', label:'Durum' },
            ]}
            formRender={(form, setForm, duz) => (
              <div className="form-grid">
                {!duz && <div className="form-group"><label>Kod (isteğe bağlı)</label><input value={form.faaliyet_kodu} onChange={e=>setForm({...form, faaliyet_kodu:e.target.value})} /></div>}
                <div className="form-group"><label>Faaliyet Adı *</label><input value={form.faaliyet_adi} onChange={e=>setForm({...form, faaliyet_adi:e.target.value})} required /></div>
                <div className="form-group"><label>Sınıf</label>
                  <select value={form.sinif_adi} onChange={e=>setForm({...form, sinif_adi:e.target.value})}>
                    <option>Sıhhi</option><option>Gayrisıhhi</option><option>Umuma Açık</option>
                  </select>
                </div>
                {duz && <div className="form-group"><label>Durum</label>
                  <select value={form.aktif} onChange={e=>setForm({...form, aktif:e.target.value==='true'})}>
                    <option value="true">Aktif</option><option value="false">Pasif</option>
                  </select>
                </div>}
              </div>
            )}
          />
        )}
        {aktifTab==='ruhsat' && (
          <GenelTanimlar
            baslik="Ruhsat Türleri" endpoint="ruhsat-turleri"
            yeniForm={{ tur_kodu:'', tur_adi:'', aciklama:'', aktif:true }}
            kolonlar={[
              { key:'tur_kodu', label:'Kod', render: v => <span style={{fontFamily:'monospace', fontSize:'12px'}}>{v}</span> },
              { key:'tur_adi', label:'Tür Adı' },
              { key:'aciklama', label:'Açıklama', render: v => <span style={{fontSize:'12px', color:'#888'}}>{v||'—'}</span> },
              { key:'aktif', label:'Durum' },
            ]}
            formRender={(form, setForm, duz) => (
              <div className="form-grid">
                {!duz && <div className="form-group"><label>Kod *</label><input value={form.tur_kodu} onChange={e=>setForm({...form, tur_kodu:e.target.value})} required /></div>}
                <div className="form-group"><label>Tür Adı *</label><input value={form.tur_adi} onChange={e=>setForm({...form, tur_adi:e.target.value})} required /></div>
                <div className="form-group" style={{gridColumn:'1/-1'}}><label>Açıklama</label><textarea value={form.aciklama||''} onChange={e=>setForm({...form, aciklama:e.target.value})} rows={2} /></div>
                {duz && <div className="form-group"><label>Durum</label>
                  <select value={form.aktif} onChange={e=>setForm({...form, aktif:e.target.value==='true'})}>
                    <option value="true">Aktif</option><option value="false">Pasif</option>
                  </select>
                </div>}
              </div>
            )}
          />
        )}
        {aktifTab==='sicil' && (
          <GenelTanimlar
            baslik="Sicil Tipleri" endpoint="sicil-tipleri"
            yeniForm={{ tip_kodu:'', tip_adi:'', aktif:true }}
            kolonlar={[
              { key:'tip_kodu', label:'Kod', render: v => <span style={{fontFamily:'monospace', fontSize:'12px'}}>{v}</span> },
              { key:'tip_adi', label:'Tip Adı' },
              { key:'aktif', label:'Durum' },
            ]}
            formRender={(form, setForm, duz) => (
              <div className="form-grid">
                {!duz && <div className="form-group"><label>Kod *</label><input value={form.tip_kodu} onChange={e=>setForm({...form, tip_kodu:e.target.value})} required /></div>}
                <div className="form-group"><label>Tip Adı *</label><input value={form.tip_adi} onChange={e=>setForm({...form, tip_adi:e.target.value})} required /></div>
                {duz && <div className="form-group"><label>Durum</label>
                  <select value={form.aktif} onChange={e=>setForm({...form, aktif:e.target.value==='true'})}>
                    <option value="true">Aktif</option><option value="false">Pasif</option>
                  </select>
                </div>}
              </div>
            )}
          />
        )}
        {aktifTab==='sirket' && (
          <GenelTanimlar
            baslik="Şirket Tipleri" endpoint="sirket-tipleri"
            yeniForm={{ tip_adi:'', aktif:true }}
            kolonlar={[
              { key:'tip_adi', label:'Şirket Tipi' },
              { key:'aktif', label:'Durum' },
            ]}
            formRender={(form, setForm, duz) => (
              <div className="form-grid">
                <div className="form-group"><label>Şirket Tipi *</label><input value={form.tip_adi} onChange={e=>setForm({...form, tip_adi:e.target.value})} required /></div>
                {duz && <div className="form-group"><label>Durum</label>
                  <select value={form.aktif} onChange={e=>setForm({...form, aktif:e.target.value==='true'})}>
                    <option value="true">Aktif</option><option value="false">Pasif</option>
                  </select>
                </div>}
              </div>
            )}
          />
        )}
        {aktifTab==='iptal' && (
          <GenelTanimlar
            baslik="İptal Nedenleri" endpoint="iptal-nedenleri"
            yeniForm={{ neden_adi:'', aktif:true }}
            kolonlar={[
              { key:'neden_adi', label:'İptal Nedeni' },
              { key:'aktif', label:'Durum' },
            ]}
            formRender={(form, setForm, duz) => (
              <div className="form-grid">
                <div className="form-group"><label>İptal Nedeni *</label><input value={form.neden_adi} onChange={e=>setForm({...form, neden_adi:e.target.value})} required /></div>
                {duz && <div className="form-group"><label>Durum</label>
                  <select value={form.aktif} onChange={e=>setForm({...form, aktif:e.target.value==='true'})}>
                    <option value="true">Aktif</option><option value="false">Pasif</option>
                  </select>
                </div>}
              </div>
            )}
          />
        )}
        {aktifTab==='belge' && <BelgeTurleri />}
        {aktifTab==='nace' && <NaceKodlari />}
      </div>
    </div>
  );
}

function NaceKodlari() {
  const { kullanici } = useContext(AuthContext);
  const [liste, setListe] = useState([]);
  const [arama, setArama] = useState('');
  const [form, setForm] = useState({ nace_kodu:'', nace_adi:'', bolum:'' });
  const [modalAcik, setModalAcik] = useState(false);
  const [duzenleme, setDuzenleme] = useState(null);
  const [hata, setHata] = useState('');
  const yazabilir = rolde(kullanici, 'admin', 'mudur');

  useEffect(() => { yukle(); }, []);
  const yukle = (q) => api.get(`/tanimlar/nace-kodlari${q ? `?q=${q}` : ''}`).then(r => setListe(r.data));

  const ac = (kayit) => {
    setDuzenleme(kayit);
    setForm(kayit ? { nace_kodu: kayit.nace_kodu, nace_adi: kayit.nace_adi, bolum: kayit.bolum||'', aktif: kayit.aktif } : { nace_kodu:'', nace_adi:'', bolum:'' });
    setHata(''); setModalAcik(true);
  };

  const kaydet = async (e) => {
    e.preventDefault(); setHata('');
    try {
      if (duzenleme) await api.put(`/tanimlar/nace-kodlari/${duzenleme.id}`, form);
      else await api.post('/tanimlar/nace-kodlari', form);
      yukle(); setModalAcik(false);
    } catch (err) { setHata(err.response?.data?.hata || 'Hata oluştu'); }
  };

  const sil = async (id) => {
    if (!window.confirm('Silmek istediğinizden emin misiniz?')) return;
    await api.delete(`/tanimlar/nace-kodlari/${id}`);
    yukle();
  };

  return (
    <div>
      <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'12px', flexWrap:'wrap', gap:'8px'}}>
        <strong>NACE Kodları</strong>
        <div style={{display:'flex', gap:'8px'}}>
          <input value={arama} onChange={e=>setArama(e.target.value)} placeholder="Kod veya isim ara..." className="search-input" style={{width:'220px'}}
            onKeyDown={e => e.key==='Enter' && yukle(arama)} />
          <button className="btn btn-outline btn-sm" onClick={() => yukle(arama)}>🔍 Ara</button>
          <button className="btn btn-outline btn-sm" onClick={() => { setArama(''); yukle(); }}>Temizle</button>
          {yazabilir && <button className="btn btn-primary btn-sm" onClick={() => ac(null)}>+ Ekle</button>}
        </div>
      </div>
      <table>
        <thead>
          <tr>
            <th>NACE Kodu</th>
            <th>NACE Adı</th>
            <th>Bölüm</th>
            <th>Durum</th>
            {yazabilir && <th>İşlem</th>}
          </tr>
        </thead>
        <tbody>
          {liste.map(n => (
            <tr key={n.id}>
              <td><span style={{fontFamily:'monospace', fontWeight:'700', color:'#1565c0'}}>{n.nace_kodu}</span></td>
              <td>{n.nace_adi}</td>
              <td style={{fontSize:'12px', color:'#666'}}>{n.bolum||'—'}</td>
              <td>{n.aktif ? '✅ Aktif' : '❌ Pasif'}</td>
              {yazabilir && (
                <td style={{display:'flex', gap:'4px'}}>
                  <button className="btn btn-outline btn-xs" onClick={() => ac(n)}>Düzenle</button>
                  <button className="btn btn-outline btn-xs" style={{color:'#c62828'}} onClick={() => sil(n.id)}>Sil</button>
                </td>
              )}
            </tr>
          ))}
          {liste.length === 0 && <tr><td colSpan="5" style={{textAlign:'center', color:'#999', padding:'20px'}}>Kayıt bulunamadı</td></tr>}
        </tbody>
      </table>

      {modalAcik && (
        <div className="modal-overlay" onClick={e => e.target===e.currentTarget && setModalAcik(false)}>
          <div className="modal" style={{maxWidth:'450px'}}>
            <div className="modal-header">
              <span className="modal-title">{duzenleme ? 'NACE Kodu Düzenle' : 'Yeni NACE Kodu'}</span>
              <button className="modal-close" onClick={() => setModalAcik(false)}>×</button>
            </div>
            {hata && <div className="alert alert-error">{hata}</div>}
            <form onSubmit={kaydet}>
              <div className="form-grid">
                <div className="form-group">
                  <label>NACE Kodu *</label>
                  <input value={form.nace_kodu} onChange={e=>setForm({...form, nace_kodu:e.target.value})} required placeholder="Örn: 47.11.00" maxLength={8} />
                </div>
                <div className="form-group" style={{gridColumn:'1/-1'}}>
                  <label>NACE Adı *</label>
                  <input value={form.nace_adi} onChange={e=>setForm({...form, nace_adi:e.target.value})} required />
                </div>
                <div className="form-group" style={{gridColumn:'1/-1'}}>
                  <label>Bölüm / Sektör</label>
                  <input value={form.bolum||''} onChange={e=>setForm({...form, bolum:e.target.value})} placeholder="Örn: G - Toptan ve Perakende Ticaret" />
                </div>
                {duzenleme && <div className="form-group"><label>Durum</label>
                  <select value={form.aktif} onChange={e=>setForm({...form, aktif:e.target.value==='true'})}>
                    <option value="true">Aktif</option><option value="false">Pasif</option>
                  </select>
                </div>}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setModalAcik(false)}>İptal</button>
                <button type="submit" className="btn btn-primary">Kaydet</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

function BelgeTurleri() {
  const { kullanici } = useContext(AuthContext);
  const [liste, setListe] = useState([]);
  const [ruhsatTurleri, setRuhsatTurleri] = useState([]);
  const [form, setForm] = useState({ ruhsat_turu_id:'', belge_adi:'', zorunlu:false, sira:0 });
  const [modalAcik, setModalAcik] = useState(false);
  const [duzenleme, setDuzenleme] = useState(null);
  const yazabilir = rolde(kullanici, 'admin', 'mudur');

  useEffect(() => {
    api.get('/tanimlar/belge-turleri').then(r => setListe(r.data));
    api.get('/tanimlar/ruhsat-turleri').then(r => setRuhsatTurleri(r.data));
  }, []);
  const yukle = () => api.get('/tanimlar/belge-turleri').then(r => setListe(r.data));

  const ac = (kayit) => {
    setDuzenleme(kayit);
    setForm(kayit ? { ruhsat_turu_id: kayit.ruhsat_turu_id, belge_adi: kayit.belge_adi, zorunlu: kayit.zorunlu, sira: kayit.sira, aktif: kayit.aktif } : { ruhsat_turu_id:'', belge_adi:'', zorunlu:false, sira:0 });
    setModalAcik(true);
  };

  const kaydet = async (e) => {
    e.preventDefault();
    try {
      if (duzenleme) await api.put(`/tanimlar/belge-turleri/${duzenleme.id}`, form);
      else await api.post('/tanimlar/belge-turleri', form);
      yukle(); setModalAcik(false);
    } catch (err) { alert(err.response?.data?.hata || 'Hata'); }
  };

  const sil = async (b) => {
    if (!window.confirm(`"${b.belge_adi}" belge türünü pasife almak istediğinizden emin misiniz?`)) return;
    try { await api.delete(`/tanimlar/belge-turleri/${b.id}`); yukle(); }
    catch (err) { alert(err.response?.data?.hata || 'Silinemedi'); }
  };

  return (
    <div>
      {yazabilir && (
        <div style={{display:'flex', justifyContent:'space-between', marginBottom:'12px'}}>
          <strong>Belge Türleri</strong>
          <button className="btn btn-primary btn-sm" onClick={() => ac(null)}>+ Ekle</button>
        </div>
      )}
      <table>
        <thead><tr><th>#</th><th>Belge Adı</th><th>Ruhsat Türü</th><th>Zorunlu</th><th>Sıra</th><th>Durum</th>{yazabilir && <th>İşlem</th>}</tr></thead>
        <tbody>
          {liste.map((b,i) => (
            <tr key={b.id}>
              <td>{i+1}</td>
              <td>{b.belge_adi}</td>
              <td style={{fontSize:'12px'}}>{b.tur_adi||'—'}</td>
              <td>{b.zorunlu ? '⚠️ Zorunlu' : 'Hayır'}</td>
              <td>{b.sira}</td>
              <td>{b.aktif ? '✅' : '❌'}</td>
              {yazabilir && <td style={{display:'flex',gap:'4px'}}><button className="btn btn-outline btn-xs" onClick={() => ac(b)}>Düzenle</button><button className="btn btn-outline btn-xs" style={{color:'#c62828'}} onClick={() => sil(b)}>Sil</button></td>}
            </tr>
          ))}
        </tbody>
      </table>
      {modalAcik && (
        <div className="modal-overlay" onClick={e => e.target===e.currentTarget && setModalAcik(false)}>
          <div className="modal" style={{maxWidth:'450px'}}>
            <div className="modal-header">
              <span className="modal-title">{duzenleme ? 'Belge Türü Düzenle' : 'Yeni Belge Türü'}</span>
              <button className="modal-close" onClick={() => setModalAcik(false)}>×</button>
            </div>
            <form onSubmit={kaydet}>
              <div className="form-grid">
                <div className="form-group" style={{gridColumn:'1/-1'}}>
                  <label>Ruhsat Türü *</label>
                  <select value={form.ruhsat_turu_id} onChange={e=>setForm({...form, ruhsat_turu_id:e.target.value})} required>
                    <option value="">Seçin...</option>
                    {ruhsatTurleri.map(r => <option key={r.id} value={r.id}>{r.tur_adi}</option>)}
                  </select>
                </div>
                <div className="form-group" style={{gridColumn:'1/-1'}}>
                  <label>Belge Adı *</label>
                  <input value={form.belge_adi} onChange={e=>setForm({...form, belge_adi:e.target.value})} required />
                </div>
                <div className="form-group">
                  <label>Sıra</label>
                  <input type="number" value={form.sira} onChange={e=>setForm({...form, sira:parseInt(e.target.value)||0})} />
                </div>
                <div className="form-group">
                  <label>Zorunlu mu?</label>
                  <select value={form.zorunlu} onChange={e=>setForm({...form, zorunlu:e.target.value==='true'})}>
                    <option value="false">Hayır</option><option value="true">Zorunlu</option>
                  </select>
                </div>
                {duzenleme && <div className="form-group">
                  <label>Durum</label>
                  <select value={form.aktif} onChange={e=>setForm({...form, aktif:e.target.value==='true'})}>
                    <option value="true">Aktif</option><option value="false">Pasif</option>
                  </select>
                </div>}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setModalAcik(false)}>İptal</button>
                <button type="submit" className="btn btn-primary">Kaydet</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
